<template>
  <div class="container-fluid py-4 users-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-person-plus fs-2 text-success"></i>

        <div>
          <h2 class="fw-bold mb-0">
            Création d'un Utilisateur
          </h2>

          <small class="text-light opacity-75">
            Les accès seront envoyés automatiquement par email
          </small>
        </div>
      </div>

      <router-link
        class="btn btn-success btn-lg shadow-sm btn-boutique mt-2 mt-md-0"
        :to="{ name: 'utilisateur' }"
      >
        <i class="bi bi-arrow-left-circle me-2"></i>
        Retour
      </router-link>

    </div>

    <!-- ================= CARD ================= -->
    <div class="card shadow-sm rounded card-boutique p-4">

      <!-- INFO -->
      <div class="alert alert-light border rounded-4 mb-4">

        <div class="d-flex align-items-start gap-3">

          <i class="bi bi-envelope-check-fill fs-3 text-success"></i>

          <div>
            <h6 class="fw-bold mb-1">
              Création automatique des accès
            </h6>

            <p class="mb-0 small text-muted">
              Un mot de passe temporaire sera généré et envoyé à l'utilisateur.
            </p>
          </div>

        </div>

      </div>

      <!-- FORM -->
      <div class="row g-4">

        <!-- NOM -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom</label>

          <input
            type="text"
            v-model="user.nom"
            class="form-control form-control-boutique"
            :class="{ 'is-invalid': error.nom }"
          >

          <div class="invalid-feedback">
            {{ error.nom }}
          </div>
        </div>

        <!-- PRENOM -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Prénom</label>

          <input
            type="text"
            v-model="user.prenom"
            class="form-control form-control-boutique"
            :class="{ 'is-invalid': error.prenom }"
          >

          <div class="invalid-feedback">
            {{ error.prenom }}
          </div>
        </div>

        <!-- USERNAME -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom utilisateur</label>

          <input
            type="text"
            v-model="user.username"
            class="form-control form-control-boutique"
            :class="{ 'is-invalid': error.username }"
          >

          <div class="invalid-feedback">
            {{ error.username }}
          </div>
        </div>

        <!-- EMAIL -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Email</label>

          <input
            type="email"
            v-model="user.email"
            class="form-control form-control-boutique"
            :class="{ 'is-invalid': error.email }"
          >

          <div class="invalid-feedback">
            {{ error.email }}
          </div>
        </div>

        <!-- ROLE -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Rôle</label>

          <select
            v-model="user.typeUser"
            class="form-select form-select-boutique"
            :class="{ 'is-invalid': error.type }"
          >
            <option value="">-- Sélectionnez --</option>

            <option
              v-for="type in typesUser.filter(t => t.nom !== 'Super Admin')"
              :key="type.id"
              :value="type.id"
            >
              {{ type.nom }}
            </option>

          </select>

          <div class="invalid-feedback">
            {{ error.type }}
          </div>
        </div>

        <!-- STATUS -->
        <div class="col-md-6 d-flex align-items-center">

          <div class="form-check form-switch">

            <input
              class="form-check-input"
              type="checkbox"
              v-model="user.enabled"
            >

            <label class="form-check-label fw-semibold ms-2">
              Utilisateur activé
            </label>

          </div>

        </div>

      </div>

      <!-- BUTTONS -->
      <div class="d-flex justify-content-end gap-3 mt-4">

        <button
          class="btn btn-outline-secondary"
          @click="cancel"
        >
          Annuler
        </button>

        <button
          class="btn btn-success btn-boutique px-4"
          :disabled="isLoading"
          @click="saveUser"
        >

          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm me-2"
          ></span>

          <i v-else class="bi bi-save me-1"></i>

          <span v-if="isLoading">
            Création...
          </span>

          <span v-else>
            Créer
          </span>

        </button>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {

      isLoading: false,

      user: {
        nom: '',
        prenom: '',
        username: '',
        email: '',
        enabled: true,
        typeUser: ''
      },

      error: {
        nom: '',
        prenom: '',
        username: '',
        email: '',
        type: ''
      },

      typesUser: []
    };
  },

  methods: {

    async getTypeUser() {
      try {
        const response = await api.getItems('type_users');
        this.typesUser = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },

    validateForm() {

      this.error = {
        nom: this.user.nom ? '' : 'Nom requis',
        prenom: this.user.prenom ? '' : 'Prénom requis',
        username: this.user.username ? '' : 'Username requis',
        email: this.user.email ? '' : 'Email requis',
        type: this.user.typeUser ? '' : 'Rôle requis'
      };

      return !Object.values(this.error).some(e => e !== '');
    },

    async saveUser() {

      if (!this.validateForm() || this.isLoading) return;

      this.isLoading = true;

      try {

        await api.createItem('users', {
          nom: this.user.nom,
          prenom: this.user.prenom,
          username: this.user.username,
          email: this.user.email,
          enabled: this.user.enabled,
          typeUser: this.user.typeUser
        });

        this.$router.push({ name: 'utilisateur' });

      } catch (error) {
        console.error(error);
        alert("Erreur lors de la création");
      } finally {
        this.isLoading = false;
      }

    },

    cancel() {
      this.$router.push({ name: 'utilisateur' });
    }

  },

  mounted() {
    this.getTypeUser();
  }
};
</script>

<style scoped>

/* ================= STYLE BOUTIQUE ================= */

.users-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* HEADER */
.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

/* CARD */
.card-boutique {
  border: none;
  border-radius: 20px;
  background: white;
}

/* INPUTS */
.form-control-boutique,
.form-select-boutique {
  border-radius: 12px;
  border: 1px solid #dbe3ec;
}

/* BUTTON */
.btn-boutique {
  border-radius: 12px;
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  border: none;
}

/* FOCUS */
.form-control-boutique:focus,
.form-select-boutique:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 0.2rem rgba(16,185,129,0.15);
}

</style>